export const applicationStatuses = [
  "all",
  "published",
  "draft",
  "inactive",
] as const;

export const elementTypes = [
  "attachment",
  "checkbox",
  "datepicker",
  "input",
  "list",
  "switch",
  "text",
  "timepicker",
  "entity",
] as const;
